import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import Search from './Search';
import Manual from './Manual';

import Box from '../../components/layout/Box';
import CollaborationPage from '../../containers/CollaborationPage';

import CreatedModal from './CreatedModal';

const NewBook = () => {
  const [sp, setSearchParams] = useSearchParams();

  const mode = sp.get('mode');
  const created = sp.get('created');

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (created) {
      setShowModal(true);
    }
  }, [created]);

  return (
    <CollaborationPage className="pt-3 pb-5">
      <Box className="flex-column">
        <Box className="flex-column">
          <h2>Sälj kurslitteratur</h2>
          <p>Här kan du skapa ett inlägg för att sälja din kurslitteratur.</p>
        </Box>

        <Box className="">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                className={`nav-link ${mode === 'search' && 'active'}`}
                aria-current="page"
                style={{
                  cursor: 'pointer',
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setSearchParams({ mode: 'search' });
                }}
              >
                Sök bok
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${mode === 'manual' && 'active'}`}
                aria-current="page"
                style={{
                  cursor: 'pointer',
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setSearchParams({ mode: 'manual' });
                }}
              >
                Manuell inmatning
              </a>
            </li>
          </ul>
        </Box>

        {mode === 'search' ? <Search /> : <Manual />}
      </Box>

      <CreatedModal
        showModal={showModal}
        handleClose={() => {
          setShowModal(false);
        }}
      />
    </CollaborationPage>
  );
};

export default NewBook;
